import { createCustomEnum } from "../customEnum";

const ScenarioTypes = createCustomEnum({
	StraightSplit: {
		value: 0,
		name: "straight_split",
		displayName: "Straight Split",
	},
	Override: {
		value: 1,
		name: "override",
		displayName: "Override",
	},
	Waterfall: {
		value: 2,
		name: "waterfall",
		displayName: "Waterfall",
	},
});

export default ScenarioTypes;
